import { useEffect, useState } from "react";
import { Plus, Pencil, Users, ImageOff } from "lucide-react";
import { api } from "../lib/api";
import HotelDialog from "../components/HotelDialog";

export default function Hotels() {
  const [hotels, setHotels] = useState([]);
  const [dialog, setDialog] = useState({ open: false, hotel: null });

  const load = () => api.get("/hotels").then((r) => setHotels(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <h1 className="font-display text-xl font-bold text-cyan-300 tracking-widest uppercase text-glow-sm">Oteller & Görseller</h1>
        <button data-testid="add-hotel-btn" onClick={() => setDialog({ open: true, hotel: null })} className="btn-cyan px-4 py-2 rounded-lg font-mono text-xs uppercase tracking-widest flex items-center gap-2">
          <Plus className="w-4 h-4" /> Otel Ekle
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {hotels.map((h) => (
          <div key={h.code} data-testid={`hotel-item-${h.code}`} className="glass-card glass-card-interactive overflow-hidden">
            <div className="h-40 bg-slate-900 bg-cover bg-center relative flex items-center justify-center" style={h.image ? { backgroundImage: `url(${h.image})` } : {}}>
              {!h.image && <ImageOff className="w-8 h-8 text-slate-600" />}
              <div className="absolute inset-0 bg-gradient-to-t from-[#050b14] to-transparent" />
            </div>
            <div className="p-4 flex items-start justify-between gap-2">
              <div>
                <div className="font-display text-base font-bold text-cyan-200">{h.name}</div>
                <div className="text-[11px] font-mono text-slate-400">{h.location || "—"}</div>
                <div className="flex items-center gap-1 text-xs text-slate-300 mt-2"><Users className="w-3 h-3 text-cyan-400" /> {h.personnel_count} personel</div>
              </div>
              <button data-testid={`edit-hotel-${h.code}`} onClick={() => setDialog({ open: true, hotel: h })} className="p-2 rounded border border-cyan-500/30 text-cyan-300 hover:bg-cyan-500/15"><Pencil className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
      <HotelDialog open={dialog.open} hotel={dialog.hotel}
        onClose={() => setDialog({ open: false, hotel: null })}
        onSaved={() => { setDialog({ open: false, hotel: null }); load(); }} />
    </div>
  );
}
